module.exports = __webpack_public_path__ + "img/1696371868177-IMG_6660.png.2b6d1aff.webp";